import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StorageModule } from '@ngx-pwa/local-storage';

import { UtilsModule } from '../utils/utils.module';
import { AuthModule } from './authentication/auth.module';
import { LandingPageModule } from './landing-page/landing-page.module';

export const routes: Routes = [

  // { path: '', redirectTo: '', pathMatch: 'full' },
  {
    path: '', children: [
      { path: 'nhip-dashboard', loadChildren: './side-bar/nhip-dashboard/nhip-dashboard.module#NhipDashboardModule', data: { preload: true } }
      // { path: '', loadChildren: './landing-page/landing-page.module#LandingPageModule', data: { preload: true}},
      // { path: 'extremeweather', loadChildren: './side-bar/extreme-weather/extreme-weather.module#ExtremeWeatherModule', data: { preload: true }  },
      // { path: 'heatwatches', loadChildren: './side-bar/heat-index/heat-index.module#HeatIndexModule', data: { preload: true }  },
      // { path: 'coldwatches', loadChildren: './side-bar/cold-watch/cold-watch.module#ColdWatchModule', data: { preload: true }  },
      // { path: 'fogwatch', loadChildren: './side-bar/fog-watch/fog-watch.module#FogWatchModule', data: { preload: true } },
      // { path: 'alert', loadChildren: './side-bar/alert/alert.module#AlertModule', data: { preload: true }  },
      // { path: 'weatherdata', loadChildren: './side-bar/weatherdata/weatherdata.module#WeatherdataModule', data: { preload: true }  },      
      // { path: 'cyclone', loadChildren: './side-bar/cyclone/cyclone.module#CycloneModule', data: { preload: true }  },
      // { path: 'observedweather', loadChildren: './side-bar/observed-weather/observed-weather.module#ObservedWeatherModule', data: { preload: true }  },
      // { path: 'drought', loadChildren: './side-bar/drought-dashboard/drought-dashboard.module#DroughtDashboardModule', data: { preload: true }  },
      // { path: 'nowcastweather', loadChildren: './side-bar/nowcast-dashboard/nowcast-dashboard.module#NowcastDashboardModule', data: { preload: true} },
      // { path: 'floodforecast', loadChildren: './side-bar/flood-forecast/flood-forecast.module#FloodForecastModule', data: { preload: true }  },
      // { path: 'drinkingwaterstress', loadChildren: './side-bar/drinking-water-stress/drinking-water.module#DrinkingWaterStressModule', data: { preload: true }  },
      // { path: 'lightning', loadChildren: './side-bar/lightning/lightning.module#LightningModule', data: { preload: true }  },
      // { path: 'mobile', loadChildren: './landing-page/mobile-dashboard/mobile-dashboard.module#MobileDashboardModule', data: { preload: true }  },
      // { path: 'webeoc', loadChildren: './side-bar/web-eoc/web-eoc.module#WebEocModule', data: { preload: true }  },
      // { path: 'createuser', loadChildren: './landing-page/createuser/createuser.module#CreateuserModule' , data: { preload: true } },
      // { path: 'webeocportal', loadChildren: './side-bar/webeoc-portal/webeoc-portal.module#WebeocPortalModule',data: { preload:true}},
      // {path: 'statereport', loadChildren: './side-bar/statereport/statereport.module#StatereportModule',data: { preload:true}},
      // { path: 'rainfallActual', loadChildren: './side-bar/rainfall-actual/rainfall.module#RainfallModule', data: { preload: true }  },
      // { path: 'heatwatch', loadChildren: './side-bar/heat-watch/heat-watch.module#HeatWatchModule', data: { preload: true }  },
      // { path: 'thunderstorms', loadChildren: './side-bar/thunderstorm/thunderstorm.module#ThunderstormModule', data: { preload: true }  },
      // { path: 'nowcastweather', loadChildren: './side-bar/nowcast-dashboard-v2/nowcast-dashboard-v2.module#NowcastDashboardV2Module', data: { preload: true} },
      // { path: 'weatherforecast', loadChildren: './side-bar/weather-forecast/weather-forecast.module#WeatherForecastModule', data: { preload: true }  },
      // { path: 'disastermonitoring', loadChildren: './side-bar/disaster-monitoring/disaster-monitoring.module#DisasterMonitoringModule', data: { preload: true }  },
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    UtilsModule,
    RouterModule.forChild(routes),
    StorageModule.forRoot({ IDBNoWrap: true }),
    LandingPageModule,
    AuthModule
  ],
  exports: [],
})
export class MainModule { }
